type LaunchAppendWaiter = {
  resolve: () => void;
  reject: (error: unknown) => void;
};

const waitersByConversation = new Map<string, LaunchAppendWaiter>();

/**
 * Registers a one-shot waiter until launch handoff is finalized (first user message
 * accepted and assistant SSE streaming started).
 */
export function registerLaunchAppendWaiter(conversationId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    waitersByConversation.set(conversationId, { resolve, reject });
  });
}

export function hasLaunchAppendWaiter(conversationId: string): boolean {
  return waitersByConversation.has(conversationId);
}

/** Resolves the launch append waiter after {@link completeLaunchDrainHandoff}. */
export function resolveLaunchAppendWaiter(conversationId: string): void {
  const waiter = waitersByConversation.get(conversationId);
  if (!waiter) return;
  waitersByConversation.delete(conversationId);
  waiter.resolve();
}

/** Rejects the launch append waiter when {@code onNew} bails or fails before streaming. */
export function rejectLaunchAppendWaiter(conversationId: string, error?: unknown): void {
  const waiter = waitersByConversation.get(conversationId);
  if (!waiter) return;
  waitersByConversation.delete(conversationId);
  waiter.reject(error ?? new Error("Launch append did not complete"));
}

/** Clears a pending waiter without resolving (e.g. handoff abort). */
export function clearLaunchAppendWaiter(conversationId: string): void {
  waitersByConversation.delete(conversationId);
}
